<template>
    <div>
        <div class="contactusaction">
            <Container>
                <div class="contactusaction__form">
                    <h1 v-html="text"></h1>
                    <ButtonBox :to="{ name: 'contato' }" outline="fill">
                      Contato
                    </ButtonBox>
                </div>
            </Container>
        </div>
    </div>
</template>

<script>
import Container from '@/components/Container'
import ButtonBox from '@/components/ButtonBox'
export default {
    name: 'contactusaction',
    components: {
        Container,
        ButtonBox,
    },
    props: {
      text: String
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.contactusaction {
    background: #fa3c3c;
    padding: 6.9rem 0;
    @media(max-width: $max-sm) {
        padding: 3rem 0;
    }
    h1 {
        color: #fff;
        font-weight: 600;
        font-size: 3.5rem;
        line-height: 6rem;
        margin-bottom: 4.7rem;
        @media(max-width: $max-sm) {
            font-size: 2.5rem;
            line-height: 3rem;
            margin-bottom: 1rem;
        }
    }
    &__form {
        text-align: center;
    }
}
</style>
